import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import union from 'lodash/union';
import {
  BULK_DELETE,
  BULK_REMOVE_FROM_GROUP,
  CREATE_CONTACT,
  DELETE_CONTACT,
  RESTORE_CONTACT,
  GET_CONTACT,
  GET_CONTACT_GROUPS,
  GET_CONTACTS,
  REMOVE_FROM_GROUP,
  RESET_CONTACTS,
  UPDATE_CONTACT,
  MERGE_CONTACT,
  ADD_COMMENT,
  EDIT_COMMENT,
  DELETE_COMMENT,
  GET_COMMENTS,
  BULK_RESTORE_CONTACTS,
  LOAD_CUSTOM_TABS,
  DELETE_CUSTOM_TAB,
  CREATE_CUSTOM_TAB,
  UPDATE_CUSTOM_TAB,
  BLOCK_CONTACT,
  UNBLOCK_CONTACT,
} from './types';
import { resolved, rejected } from 'store/createAction';

const initialState = {
  loading: false,
  loadingContact: false,
  loadingGroup: false,
  ids: [],
  entities: {},
  contactGroups: {},
  contactComments: {
    /* example
   [contact_id]: []
  */
  },
  customTabs: [],
  limit: 50,
  offset: 0,
  hasMore: true,
};

export default (state = initialState, action) => {
  const { type, payload, meta } = action;
  switch (type) {
    case RESET_CONTACTS:
      return {
        ...initialState,
      };
    case GET_CONTACTS:
      return {
        ...state,
        loading: true,
      };
    case resolved(GET_CONTACTS): {
      const ids = map(payload, 'hash');
      const entities = keyBy(payload, 'hash');
      const contactGroups = state.contactGroups;
      payload.forEach((c) => {
        contactGroups[c.hash] = c.groups;
      });
      if (meta.reset) {
        return {
          ...state,
          loading: false,
          ids,
          entities: {
            ...state.entities,
            ...entities,
          },
          contactGroups: { ...contactGroups },
          offset: 0,
          limit: meta.query.limit,
          hasMore: payload.length === meta.query.limit,
        };
      }
      return {
        ...state,
        loading: false,
        ids: union(state.ids, ids),
        entities: {
          ...state.entities,
          ...entities,
        },
        contactGroups: { ...contactGroups },
        offset: meta.query.offset,
        hasMore: payload.length === meta.query.limit,
      };
    }
    case GET_CONTACT: {
      return {
        ...state,
        loadingContact: true,
      };
    }
    case rejected(GET_CONTACT): {
      return {
        ...state,
        loadingContact: false,
      };
    }
    case resolved(GET_CONTACT): {
      return {
        ...state,
        loadingContact: false,
        entities: {
          ...state.entities,
          [meta.id]: payload,
        },
        contactGroups: {
          ...state.contactGroups,
          [payload.hash]: payload.groups,
        },
      };
    }
    case resolved(CREATE_CONTACT): {
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.hash]: payload,
        },
        ids: union([...state.ids, payload.hash]),
      };
    }
    case GET_CONTACT_GROUPS:
      return {
        ...state,
        loadingGroup: true,
      };
    case rejected(GET_CONTACT_GROUPS): {
      return {
        ...state,
        loadingGroup: false,
      };
    }
    case resolved(GET_CONTACT_GROUPS): {
      const contact = state.entities[meta.hash] || {};
      contact.groups = payload;
      return {
        ...state,
        loadingGroup: false,
        entities: {
          ...state.entities,
          [meta.hash]: contact,
        },
        // contactGroups: {
        //   ...state.contactGroups,
        //   [meta.hash]: payload,
        // },
      };
    }
    case resolved(UPDATE_CONTACT): {
      const contact = state.entities[meta.id];
      if (!payload.contact_image_url) {
        payload.contact_image_full_url = '';
      }
      return {
        ...state,
        entities: {
          ...state.entities,
          [meta.id]: Object.assign({}, contact, payload),
        },
      };
    }
    case resolved(DELETE_CONTACT):
    case resolved(BLOCK_CONTACT):
    case resolved(UNBLOCK_CONTACT):
    case resolved(RESTORE_CONTACT): {
      const { entities, ids } = state;
      delete entities[meta.id];
      return {
        ...state,
        entities: { ...entities },
        ids: ids.filter((c) => c !== meta.id),
      };
    }
    case resolved(BULK_RESTORE_CONTACTS):
    case resolved(BULK_DELETE): {
      const { entities, ids } = state;
      meta.ids.forEach((id) => {
        delete entities[id];
      });
      return {
        ...state,
        entities: {
          ...state.entities,
          ...entities,
        },
        ids: ids.filter((c) => !meta.ids.includes(c)),
      };
    }
    case resolved(BULK_REMOVE_FROM_GROUP): {
      const { entities } = state;
      const updates = {};
      const contacts = Object.values(entities);
      meta.ids.forEach((id) => {
        const contact = contacts.find((c) => c.hash === id);
        if (contact) {
          contact.groups = contact.groups
            ? contact.groups.filter((g) => g.hash !== meta.groupHash)
            : [];
          updates[contact.hash] = contact;
        }
      });
      return {
        ...state,
        entities: {
          ...state.entities,
          ...updates,
        },
      };
    }
    case resolved(REMOVE_FROM_GROUP): {
      const contact = Object.values(state.entities).find(
        (c) => c.hash === meta.contactHash,
      );
      if (contact) {
        contact.groups = contact.groups
          ? contact.groups.filter((g) => g.hash !== meta.groupHash)
          : [];
        return {
          ...state,
          entities: {
            ...state.entities,
            [contact.hash]: { ...contact },
          },
        };
      }
      return state;
    }
    case resolved(MERGE_CONTACT): {
      const { entities, ids } = state;
      const { contact1, contact2 } = meta;
      const contact1Obj = Object.values(entities).find(
        (c) => c.hash === contact1,
      );
      const contact2Obj = Object.values(entities).find(
        (c) => c.hash === contact2,
      );
      if (!payload.contact_image_url) {
        payload.contact_image_full_url = '';
      }
      delete entities[contact1Obj.hash];
      return {
        ...state,
        entities: {
          ...entities,
          [contact2Obj.hash]: Object.assign({}, contact1Obj, payload),
        },
        ids: ids.filter((c) => c !== contact1Obj.hash),
      };
    }
    case ADD_COMMENT:
    case EDIT_COMMENT:
    case DELETE_COMMENT:
    case GET_COMMENTS: {
      return {
        ...state,
        contactComments: {
          ...state.contactComments,
          loading: true,
        },
      };
    }
    case resolved(GET_COMMENTS): {
      if (payload.length) {
        const contactId = payload[0].contact_id;
        return {
          ...state,
          contactComments: {
            ...state.contactComments,
            [contactId]: payload,
            loading: false,
          },
        };
      }
      return {
        ...state,
        contactComments: {
          ...state.contactComments,
          loading: false,
        },
      };
    }
    case resolved(ADD_COMMENT): {
      const comments = state.contactComments[payload.contact_id] || [];
      return {
        ...state,
        contactComments: {
          ...state.contactComments,
          [payload.contact_id]: [...comments, payload],
          loading: false,
        },
      };
    }
    case resolved(EDIT_COMMENT): {
      const comments = state.contactComments[payload.contact_id];
      return {
        ...state,
        contactComments: {
          ...state.contactComments,
          [payload.contact_id]: comments.map((i) =>
            i.hash === payload.hash ? payload : i,
          ),
          loading: false,
        },
      };
    }
    case resolved(DELETE_COMMENT): {
      const comments = state.contactComments[meta.comment.contact_id];
      return {
        ...state,
        contactComments: {
          ...state.contactComments,
          [meta.comment.contact_id]: comments.filter(
            (c) => c.hash !== meta.comment.hash,
          ),
          loading: false,
        },
      };
    }
    case resolved(LOAD_CUSTOM_TABS): {
      return {
        ...state,
        customTabs: payload,
      };
    }
    case resolved(CREATE_CUSTOM_TAB): {
      return {
        ...state,
        customTabs: [...state.customTabs, payload],
      };
    }
    case resolved(UPDATE_CUSTOM_TAB): {
      return {
        ...state,
        customTabs: state.customTabs.map((t) =>
          t.hash === payload.hash ? payload : t,
        ),
      };
    }
    case resolved(DELETE_CUSTOM_TAB): {
      return {
        ...state,
        customTabs: state.customTabs.filter((t) => t.hash !== meta.hash),
      };
    }
    case rejected(ADD_COMMENT):
    case rejected(EDIT_COMMENT):
    case rejected(DELETE_COMMENT):
    case rejected(GET_COMMENTS):
      return {
        ...state,
        contactComments: {
          ...state.contactComments,
          loading: false,
        },
      };
    default:
      return state;
  }
};
